import { createFileRoute, stripSearchParams } from "@tanstack/react-router";

export type FlueStatusSearchParams = {
  search?: string;
  postalCode?: string;
  problematicFlue?: boolean;
  mainTab?: string;
};

const defaultValues: FlueStatusSearchParams = {
  search: "",
  postalCode: "",
  problematicFlue: undefined,
  mainTab: "overview",
};
export const Route = createFileRoute("/flue-status")({
  validateSearch: (params: Record<string, unknown>): FlueStatusSearchParams => {
    // validate and parse the search params into a typed state
    return {
      search: params["search"]?.toString() ?? "",
      postalCode: params["postalCode"]?.toString() ?? "",
      problematicFlue: params["problematicFlue"] as boolean | undefined,
    };
  },
  search: {
    middlewares: [stripSearchParams(defaultValues)],
  },
});
